<template>
  <div
    v-element-value="value"
    class="text-input"
  >
    <textarea
      v-bind="proxyAttrs"
      v-model="proxyValue"
      v-autosize
      v-on="$listeners"
    />
  </div>
</template>

<script>
import { getCurrentInstance, computed } from 'vue-demi'

export const SOURCE = 'value'
export const EVENT = 'onChange'

export default {
  components: {
  },
  model: {
    prop: SOURCE,
    event: EVENT,
  },
  props: {
    [SOURCE]: {
      default: () => '',
      required: true,
      validator: val => typeof val === 'string' || val === null,
    },
    checkerOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props, { emit }) {
    const { proxy } = getCurrentInstance()
    const proxyAttrs = computed(() => {
      return Object.assign({ }, proxy.$attrs)
    })
    const proxyValue = computed({
      get () { return props[SOURCE] },
      set (newValue) {
        emit(EVENT, newValue)
      },
    })

    return {
      proxyAttrs,
      proxyValue,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/textField';
.text-input {
  &.fusion-input-check-is-invalid-input {
    textarea {
      background-color: #f9ecea;
    }
  }
  textarea {
    width: 100%;
  }
}
</style>
